module.exports = __webpack_public_path__ + "images/placeholder-project-statistic-mobile-4bcc07dcf62a2633eed52637ee4b93ea.png";